'use strict';

module.exports = function values() {
  var _this = this;

  var collection = [];

  Object.keys(this.items).forEach(function (property) {
    collection.push(_this.items[property]);
  });

  return new this.constructor(collection);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/values.js
// module id = 1286
// module chunks = 2